// Histórico local do Chat (IndexedDB). O servidor não guarda mensagens decifradas; este é o único histórico.
import { openDB } from "idb";

let dbp = null;
const open = () => (dbp ||= openDB("ga-chat", 1, {
  upgrade(db) {
    const m = db.createObjectStore("messages", { keyPath: "id" });
    m.createIndex("peer", "peer");
    m.createIndex("expiresAt", "expiresAt");
    db.createObjectStore("meta");
  },
}));

export const chatDb = {
  async put(msg) { return (await open()).put("messages", msg); },
  async get(id) { return (await open()).get("messages", id); },
  async remove(id) { return (await open()).delete("messages", id); },
  async byPeer(peer) { const all = await (await open()).getAllFromIndex("messages", "peer", peer); return all.sort((a, b) => a.sentAt - b.sentAt); },
  async lastByPeer() {
    const all = await (await open()).getAll("messages");
    const out = {};
    for (const m of all) if (!out[m.peer] || out[m.peer].sentAt < m.sentAt) out[m.peer] = m;
    return out;
  },
  async unreadCounts() {
    const all = await (await open()).getAll("messages");
    const out = {};
    for (const m of all) if (!m.mine && !m.read) out[m.peer] = (out[m.peer] || 0) + 1;
    return out;
  },
  async markRead(peer) {
    const db = await open();
    const tx = db.transaction("messages", "readwrite");
    for (const m of await tx.store.index("peer").getAll(peer)) if (!m.mine && !m.read) { m.read = true; await tx.store.put(m); }
    await tx.done;
  },
  async clearPeer(peer) {
    const db = await open();
    const tx = db.transaction("messages", "readwrite");
    for (const k of await tx.store.index("peer").getAllKeys(peer)) await tx.store.delete(k);
    await tx.done;
  },
  async purgeExpired(now = Date.now()) {
    const db = await open();
    const tx = db.transaction("messages", "readwrite");
    const expired = await tx.store.index("expiresAt").getAll(IDBKeyRange.upperBound(now));
    for (const m of expired) await tx.store.delete(m.id);
    await tx.done;
    return expired.map((m) => m.id);
  },
  async getMeta(key) { return (await open()).get("meta", key); },
  async setMeta(key, value) { return (await open()).put("meta", value, key); },
  async wipe() { const db = await open(); await db.clear("messages"); await db.clear("meta"); },
};
